import { IMAGES_ASSETS_URL } from '../constants/links';
import { CreditCardBrands } from '../constants/credit-cards';
import { allowanceStatus, CardStatus } from '../models/proallowance';
var getImagePath = function (path) { return "".concat(IMAGES_ASSETS_URL).concat(path); };
export var getCardImagePath = function (cardBrand, cardType) {
    switch (cardBrand) {
        case CreditCardBrands.PROP:
            return getImagePath('/credit-card-pro-purchase.png');
        case CreditCardBrands.PROX:
            return getImagePath('/credit-card-prox.png');
        case CreditCardBrands.HDCOM:
            return cardType === 'HR'
                ? getImagePath('/credit-card-commercial-revolving.png')
                : getImagePath('/credit-card-prox.png');
        case CreditCardBrands.VISA:
            return getImagePath('/credit-card-visa.png');
        case CreditCardBrands.MA:
            return getImagePath('/credit-card-mastercard.png');
        case CreditCardBrands.AMEX:
            return getImagePath('/credit-card-amex.png');
        case CreditCardBrands.DISC:
            return getImagePath('/credit-card-discover.png');
        case CreditCardBrands.HDCON:
            return getImagePath('/credit-card-hd-consumer.png');
        default:
            return '';
    }
};
export var getCardBrandName = function (cardBrand) {
    switch (cardBrand) {
        case CreditCardBrands.VISA:
            return 'Visa';
        case CreditCardBrands.MA:
            return 'Mastercard';
        case CreditCardBrands.AMEX:
            return 'American Express';
        case CreditCardBrands.DISC:
            return 'Discover';
        default:
            return '';
    }
};
export var getAllowanceStatus = function (status, assigneeExists, cardNumberLast4, cardStatus) {
    if (status === allowanceStatus.ACTIVE &&
        assigneeExists &&
        cardNumberLast4 &&
        cardStatus === CardStatus.ACTIVE) {
        return 'Active';
    }
    if (status === allowanceStatus.EXPIRED) {
        return 'Expired';
    }
    return 'Disabled';
};
